import React, { Component } from 'react';
import { Row, Col, Button, ButtonGroup } from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Table from './components/Table';
import Form from './components/Form';
import API from '../../services/API';
import Icon from "../../components/Icon";
import SyncMessage from "../../components/SyncMessage";

class BidderSources extends Component {
    constructor() {
        super();

        this.state = {
            isLoading: false,
            isShowForm: false,
            sourceToUpdate: null,
            sortParam: null,
            sortOrder: 1,
            sources: [],
            availableSources: [],
            types: [],
            syncData: null
        };

        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleSync = this.handleSync.bind(this);
        this.handleUpdateBtnClick = this.handleUpdateBtnClick.bind(this);
        this.handleRemoveBtnClick = this.handleRemoveBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
    }

    componentDidMount() {
        Promise.all([
            API.BidderSources.getAvailableSources(),
            API.BidderSources.getTypes()
        ]).then(([ sources, { types } ]) => {
            this.setState({ availableSources: sources, types });
        });

        this.loadSources();
    }

    componentWillUpdate(nextProps, nextState) {
        const { sources, sortParam, sortOrder } = nextState;

        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(sources, sortParam, sortOrder);

            this.setState({ sources });
        }
    }

    sortReport(sources, sortParam, sortOrder) {
        sources.sort((objA, objB) => {
            if(objA[sortParam] > objB[sortParam]) return 1 * sortOrder;
            else if(objA[sortParam] < objB[sortParam]) return -1 * sortOrder;

            return 0;
        });
    }

    loadSources() {
        this.setState({ isLoading: true });

        API.BidderSources.get().then(sources => this.setState({ sources, isLoading: false }));
    }

    handleAddBtnClick() {
        this.setState({ isShowForm: true });
    }

    handleFormHide() {
        this.setState({ isShowForm: false, payoutToUpdate: null });
    }

    handleFormSubmit(source) {
        this.setState({
            isShowForm: false,
            isLoading: true,
            sourceToUpdate: null
        });

        if(source.id) {
            const id = source.id;

            delete source.id;

            API.BidderSources.update(id, source).then(() => this.loadSources());
        }
        else API.BidderSources.save(source).then(() => this.loadSources());
    }

    handleUpdateBtnClick(source) {
        this.setState({ isShowForm: true,  sourceToUpdate: source });
    }

    handleRemoveBtnClick(name) {
        this.setState({ isLoading: true });

        API.BidderSources.remove(name).then(() => this.loadSources());
    }

    handleSync() {
        this.setState({ isLoading: true });

        API.Sync(['bidder', 'bidder-adk'], 'sources', 8081)
            .then((res) => {
                this.setState({ isLoading: false, syncData: { res } });
            })
            .catch(err => {
                this.setState({ isLoading: false, syncData: { reqErr: err } });
            });
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    getForm() {
        if(this.state.isShowForm) {
            return <Form
                availableSources={this.state.availableSources}
                onSubmit={this.handleFormSubmit}
                onFormHide={this.handleFormHide}
                source={this.state.sourceToUpdate}
                types={this.state.types}
            />;
        }
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Bidder Sources"/>
                <Row>
                    <Col lg={12}>
                        <ButtonGroup className="pull-right m-b-15">
                            <Button bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus"/> Add</Button>
                            <Button bsStyle="info" onClick={this.handleSync}> Sync</Button>
                        </ButtonGroup>
                    </Col>
                </Row>
                <SyncMessage {...this.state.syncData} />

                {this.getForm()}

                <Table sources={this.state.sources} onRemove={this.handleRemoveBtnClick} onUpdate={this.handleUpdateBtnClick} onSort={this.handleSort}/>
            </Container>
        );
    }
}

export default BidderSources;


// WEBPACK FOOTER //
// ./src/scenes/BidderSources/index.js